import '../assets/NcAppNavigationSettings.css';
import { defineComponent, ref, useTemplateRef, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, withCtx, createTextVNode, toDisplayString, Transition, withDirectives, renderSlot, vShow } from "vue";
import { x as mdiCog, y as mdiCogOutline } from "./mdi.mjs";
import { onClickOutside } from "@vueuse/core";
import { N as NcButton } from "./NcButton.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper.mjs";
import { r as register, B as t48, a as t } from "./_l10n.mjs";
import { c as createElementId } from "./createElementId.mjs";
import { a as isLegacy } from "./legacy.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
register(t48);
const _hoisted_1 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppNavigationSettings",
  props: {
    excludeClickOutsideSelectors: { default: () => [] },
    name: { default: () => t("Settings") }
  },
  setup(__props) {
    const contentId = createElementId();
    const open = ref(false);
    const container2 = useTemplateRef("wrapperElement");
    const ignore = computed(() => Array.isArray(__props.excludeClickOutsideSelectors) ? __props.excludeClickOutsideSelectors : __props.excludeClickOutsideSelectors.split(" "));
    onClickOutside(container2, () => {
      open.value = false;
    }, { ignore });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: "wrapperElement",
        class: normalizeClass(_ctx.$style.container)
      }, [
        createElementVNode("div", {
          class: normalizeClass(_ctx.$style.header)
        }, [
          createVNode(NcButton, {
            "aria-controls": unref(contentId),
            "aria-expanded": open.value ? "true" : "false",
            class: normalizeClass(_ctx.$style.button),
            alignment: "start",
            variant: "tertiary",
            wide: "",
            onClick: _cache[0] || (_cache[0] = ($event) => open.value = !open.value)
          }, {
            icon: withCtx(() => [
              createVNode(NcIconSvgWrapper, {
                path: unref(isLegacy) ? unref(mdiCog) : unref(mdiCogOutline)
              }, null, 8, ["path"])
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(__props.name), 1)
            ]),
            _: 1
          }, 8, ["aria-controls", "aria-expanded", "class"])
        ], 2),
        createVNode(Transition, {
          enterActiveClass: _ctx.$style.animationActive,
          leaveActiveClass: _ctx.$style.animationActive,
          enterFromClass: _ctx.$style.animationStop,
          leaveToClass: _ctx.$style.animationStop
        }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              id: unref(contentId),
              class: normalizeClass(_ctx.$style.content)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 10, _hoisted_1), [
              [vShow, open.value]
            ])
          ]),
          _: 3
        }, 8, ["enterActiveClass", "leaveActiveClass", "enterFromClass", "leaveToClass"])
      ], 2);
    };
  }
});
const container = "_container_xI0aW";
const header = "_header_SBKjd";
const button = "_button_q-hTK";
const content = "_content_dIvPc";
const animationActive = "_animationActive_QkEzk";
const animationStop = "_animationStop_oedIi";
const style0 = {
  container,
  header,
  button,
  content,
  animationActive,
  animationStop
};
const cssModules = {
  "$style": style0
};
const NcAppNavigationSettings = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAppNavigationSettings as N
};
//# sourceMappingURL=NcAppNavigationSettings.mjs.map
